import { get } from 'lodash';
import { AxiosClient } from 'src/configs/axios/axios';

const PAGE_CONTENT_API = {
  listPageContentAPI: async (params: PageContent.GetListPageContentParams) => {
    const response = await new AxiosClient().get('/page/content', { params })
    return get(response, 'data', null)
  },
  detailPageContentAPI: async (id: string) => {
    const response = await new AxiosClient().get(`/page/content/${id}`)
    return get(response, 'data', null)
  },
  createPageContentAPI: async (params: PageContent.PageContentPostDetailParams) => {
    const response = await new AxiosClient().post('/page/content', params)
    const data = get(response, 'data', null)
    return data
  },
  updatePageContentAPI: async (params: PageContent.PageContentPostDetailParams) => {
    const response = await new AxiosClient().put(
      `/page/content/${params.id}`,
      params
    )
    const data = get(response, 'data', null)
    return data
  },
  deletePageContentAPI: async (id: string) => {
    const response = await new AxiosClient().delete('/page/content/' + id)
    const data = get(response, 'data', null)
    return data
  },
  listOrderContentAPI: async (params: PageContent.GetListOrdersParams) => {
    const response = await new AxiosClient().get('/page/content/sort-order', { params })
    const data = get(response, 'data', null)
    return data
  },
  sortOrderContentAPI: async (params: PageContent.PostSortOrderParams) => {
    const response = await new AxiosClient().put(`/page/content/sort-order/${params.sessionId}`, params.orders)
    const data = get(response, 'data', null)
    return data
  },
}

export default PAGE_CONTENT_API
